// extracted by mini-css-extract-plugin
export var box = "style-module--box--82403";
export var boxes = "style-module--boxes--862c4";
export var content = "style-module--content--9e927";
export var cta = "style-module--cta--f933e";
export var loggedOut = "style-module--loggedOut--daf05";
export var proceed = "style-module--proceed--391af";